var path = '/templates/projects.dashboard/campaign_count_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.campaignCountChart.campaignCount' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.campaigns class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.dashboard/campaign_count_chart.html
// module id = 1449
// module chunks = 0